import React from 'react';
import Hero from '../components/home/Hero';
import Features from '../components/home/Features';
import Screenshots from '../components/home/Screenshots';
import HowItWorks from '../components/home/HowItWorks';

const Home = () => {
  return (
    <div className="flex flex-col">
      <Hero />
      <Features />
      <Screenshots />
      <HowItWorks />
    </div>
  );
};

export default Home;